import React from "react";
import { Search, X } from "lucide-react";
import "./SearchInput.scss";

/**
 * SearchInput — Reusable search input with icon, clear button, and optional debounce.
 *
 * Props:
 *   value       — controlled value
 *   onChange     — callback(newValue)
 *   placeholder  — placeholder text
 *   className    — extra class
 *   autoFocus    — auto focus on mount
 */
const SearchInput = ({
  value = "",
  onChange,
  placeholder = "Search…",
  className = "",
  autoFocus = false,
}) => (
  <div className={`search-input-box ${className}`}>
    <Search size={16} className="search-input-box__icon" />
    <input
      type="text"
      className="search-input-box__field"
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      autoFocus={autoFocus}
    />
    {value && (
      <button
        type="button"
        className="search-input-box__clear"
        onClick={() => onChange?.("")}
        aria-label="Clear search"
      >
        <X size={14} />
      </button>
    )}
  </div>
);

export default SearchInput;
